<template>
  <a-modal v-model="modal" title="批量修改" width="500px" :maskClosable="false" :closable="false">
    <a-form-model
      :model="formData"
      ref="form"
    >
      <a-form-model-item
        label="计划开始时间"
        :labelCol="{ style: 'width: 120px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
        prop="scheduledStartDate"
        :rules="rules"
        v-if="fieldType==='scheduledStartDate'"
      >
        <a-date-picker
          v-model="formData.scheduledStartDate"
          format="YYYY-MM-DD HH:mm:ss"
          valueFormat="YYYY-MM-DD HH:mm:ss"
          :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
          :disabled-date="disabledDate"
        />
      </a-form-model-item>
      <a-form-model-item
        label="计划完成时间"
        :labelCol="{ style: 'width: 120px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
        prop="scheduledCompletionDate"
        :rules="rules"
        v-if="fieldType==='scheduledCompletionDate'"
      >
        <a-date-picker
          v-model="formData.scheduledCompletionDate"
          format="YYYY-MM-DD HH:mm:ss"
          valueFormat="YYYY-MM-DD HH:mm:ss"
          :show-time="{ defaultValue: moment('23:59:59', 'HH:mm:ss') }"
          :disabled-date="disabledDate"
        />
      </a-form-model-item>
      <a-form-model-item label="工作中心" prop="workCenterCode" v-if="fieldType==='workCenterCode'" :rules="rules">
        <global-select
          :value.sync="formData.workCenterCode"
          selectType="selectAssembleSearch"
          assembleLabel
          searchParam="centerName"
          focusGet
          requestApi="/bom/workCenter/list"
          :selectItem="{ value: 'centerCode', label: 'centerName' }"
          :setParams="{ workshopCode: baseData.workCode }"
        />
      </a-form-model-item>
      <a-form-model-item label="班组" prop="teamGroupCode" v-if="fieldType==='teamGroupCode'" :rules="rules">
        <global-select
          :value.sync="formData.teamGroupCode"
          selectType="selectAssembleSearch"
          assembleLabel
          searchParam="teamName"
          focusGet
          requestApi="/bom/team/list"
          :selectItem="{ value: 'teamCode', label: 'teamName' }"
          :setParams="{ workshopCode: baseData.workCode, centerCode: baseData.workCenterCode }"
        />
      </a-form-model-item>
    </a-form-model>
    <template #footer>
      <a-space>
        <a-button :loading="loading" @click="modal=false;$refs.form.resetFields();">取消</a-button>
        <a-button type="primary" @click="submit" :loading="loading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import moment from 'moment';
import { apiBatchUpdateMesDiscreteJobsCc } from '@/api/mes/workOrderManage/moTickets.js';

export default {
  name: 'BatchEditModal',
  data() {
    return {
      fieldType: '', // 修改字段标识
      modal: false,
      signVal: '', // 标识字段
      formData: {
        scheduledStartDate: "",
        scheduledCompletionDate: '',
        teamGroupCode: '',
        workCenterCode: ''
      },
      baseData: {
        teamGroupCode: '',
        workCenterCode: '',
        workshopCode: ''
      },
      loading: false,
      rules: [{ required: true, message: ' ', trigger: 'change' }],
      selectedRows: []
    }
  },
  methods: {
    moment,
    show (list, field, sign) {
      this.fieldType = field // 区分修改字段标识
      this.signVal = sign
      this.selectedRows = list;
      const firstItem = list[0];
      this.baseData = {
        teamGroupCode: firstItem.teamGroupCode,
        workCenterCode: firstItem.workCenterCode,
        workCode: firstItem.workCode
      }
      this.formData = {
        scheduledStartDate: '',
        scheduledCompletionDate: '',
        workCenterCode: '',
        teamGroupCode: ''
      }
      this.modal = true
    },
    submit () {
      this.$refs.form.validate(valid => {
        if(valid) {
          const ids = this.selectedRows.map(item => item.id)
          const params = { ids: ids, [this.fieldType]: this.formData[this.fieldType] }
          // 修改计划完成时间，计划开始时间默认为完成时间当天的8点
          if(this.fieldType === 'scheduledCompletionDate') {
            params.scheduledStartDate = this.$moment(this.formData[this.fieldType]).format('YYYY-MM-DD 08:00:00')
          }
          this.loading = true;
          apiBatchUpdateMesDiscreteJobsCc(params).then(response => {
            if (response.code === 200) {
              this.modal = false
              this.$message.success('修改完成!')
              this.$emit("click")
            } else {
              this.$message.error(response.msg)
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    // 选择限制当前和以后日期
    disabledDate (current) {
      return current && current <= this.$moment().subtract(1, 'day');
    }
  }
}
</script>

<style scoped>

</style>
